import { IRouterPaths } from "../types/interfaces/IRouterPaths.interface";

export const ROUTER_PATHS: IRouterPaths = {
  // DEFAULT PATH IS ONLY LOGIN PAGE
  defaultPath: "/sign-in",

  // AUTH PAGES
  auth: {
    defaultPath: "/sign-in",
    signIn: {
      path: "/sign-in",
    },
    signUp: {
      path: "/sign-up",
    },
    forgotPassword: {
      path: "/forgot-password",
    },
  },

  // BACK OFFICE PAGES
  backOffice: {
    defaultPath: "/inventory",
    users: {
      path: "/users",
    },
    inventory: {
      path: "/inventory",
    },
    bloodClinical: {
      path: "/blood-clinical",
    },
    researchAreas: {
      path: "/research-areas",
    },
    clientOrders: {
      path: "/client-orders",
    },
    clientCompanies: {
      path: "/client-companies",
    },
    vendors: {
      path: "/vendors",
    },
    nonInventory: {
      path: "/non-inventory",
    },
    vendorOrders: {
      path: "/vendor-orders",
    },
    contactUs: {
      path: "/contact-us",
    },
    profile: {
      path: "/profile",
    },
    biomarkers: {
      path: "/biomarkers",
    },
    infectiousDonors: {
      path: "/infectious-donors",
    },
  },

  // CLIENT AREA PAGES
  clientArea: {
    defaultPath: "/inventory",
    inventory: {
      path: "/inventory",
    },
    specimenSearch: {
      path: "/specimen-search",
      // todo
      loincList: {
        path: "/specimen-search/loinc-list",
      },
    },
    clinicalSwabs: {
      path: "/clinical-swabs",
    },
    clinicalUrine: {
      path: "/clinical-urine",
    },
    clinicalFecal: {
      path: "/clinical-fecal",
    },
    infectiousDonors: {
      path: "/infectious-donors",
    },
    healthyDonors: {
      path: "/healthy-donors",
    },
    tissueBlocks: {
      path: "/tissue-blocks",
    },
    muscleFlesh: {
      path: "/muscle-flesh",
    },
    orders: {
      path: "/orders",
    },
    cart: {
      path: "/cart",
    },
    nonInventory: {
      path: "/non-inventory",
    },
    contactUs: {
      path: "/contact-us",
    },
    profile: {
      path: "/profile",
    },
  },
};
